var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"panel-icon",class:{start_animation:!_vm.showPanel},attrs:{"id":"icon-container"}},[_c('img',{attrs:{"src":"assets/handsShake.jpg","id":"icon","alt":"shaek-hands-logo"},on:{"click":_vm.togglePanelMethod}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }